module.exports = __webpack_public_path__ + "static/media/25.3172ff64.png";